import { Avatar } from "antd";
import { BellOutlined } from "@ant-design/icons";

export const NotificationBell = () => {
  return (
    <Avatar className="bg-accent">
      <BellOutlined
        className="notification-icon"
        style={{ color: "white", fontSize: 14 }}
      />
    </Avatar>
  );
};